"use client";
/* Auto-generated. Do not edit. */
/* Source: src/pages/home-modules/home-ten/sections/bannerSection.tsx */

import { SmartImage } from "@/Components";
import { SmartLink } from "@/Components";
import { renderCollectionNode, renderItemNode, renderNode } from "@/Templates/section-node-renderers";
import { FC, ComponentProps, Key, ReactNode } from "react";

type BannerSectionAvatarsItem = {
    key: Key | null | undefined;
    /** Detected variants: "/Templates/Doccure/img/patients/patient24.jpg" | "/Templates/Doccure/img/patients/patient25.jpg" | "/Templates/Doccure/img/patients/patient26.jpg" | "/Templates/Doccure/img/patients/patient27.jpg" */
    src: string;
    /** Detected variants: "avatar" */
    className?: string;
    /** Detected variants: "patient" */
    alt?: string;
    /** Detected variants: "img-fluid rounded-circle" */
    imageWithBasePath0ClassName?: string;
};
export type HomeTenBannerSectionGeneratedProps = {
    sectionDiv0Div0ClassName?: string;
    /** Default: "0.2s" */
    sectionDiv0Div0Div0Div0DivDataWowDelay?: string;
    /** Default: "1s" */
    sectionDiv0Div0Div0Div0DivDataWowDuration?: string;
    /** Default: "all_routes.booking" */
    sectionDiv0Div0Div0Div0Div0Link0LinkHref?: string;
    /** Default: "Book Consultation" */
    sectionDiv0Div0Div0Div0Div0Link0LinkText?: ReactNode;
    sectionDiv0Div0Div0Div0Div0Link0LinkVisible?: boolean;
    sectionDiv0Div0Div0Div0Div0Link0LinkRenderer?: (defaultNode: ReactNode) => ReactNode;
    sectionDiv0Div0Div0Div0Div0Link0LinkProps?: Partial<ComponentProps<typeof SmartLink>>;
    /** Default: "all_routes.search1" */
    sectionDiv0Div0Div0Div0Div0Link1LinkHref?: string;
    /** Default: "Search Specialist" */
    sectionDiv0Div0Div0Div0Div0Link1LinkText?: ReactNode;
    sectionDiv0Div0Div0Div0Div0Link1LinkVisible?: boolean;
    sectionDiv0Div0Div0Div0Div0Link1LinkRenderer?: (defaultNode: ReactNode) => ReactNode;
    sectionDiv0Div0Div0Div0Div0Link1LinkProps?: Partial<ComponentProps<typeof SmartLink>>;
    /** Default: "#" */
    sectionDiv0Div0Div0Div0Div1Div0Link0LinkHref?: string;
    /** Default: "10k+" */
    sectionDiv0Div0Div0Div0Div1Div0Link0LinkText?: ReactNode;
    sectionDiv0Div0Div0Div0Div1Div0Link0LinkVisible?: boolean;
    sectionDiv0Div0Div0Div0Div1Div0Link0LinkRenderer?: (defaultNode: ReactNode) => ReactNode;
    sectionDiv0Div0Div0Div0Div1Div0Link0LinkProps?: Partial<ComponentProps<typeof SmartLink>>;
    /** Default: "A trusted partner in every patient's fertility journey." */
    sectionDiv0Div0Div0Div0Div1P0PText?: ReactNode;
    /** Default: "Your Journey to" */
    sectionDiv0Div0Div0Div0H10H1Text?: ReactNode;
    /** Default: "Begins Here" */
    sectionDiv0Div0Div0Div0H10H1Text2?: ReactNode;
    sectionDiv0Div0Div0Div0H10H1Visible?: boolean;
    sectionDiv0Div0Div0Div0H10H1Renderer?: (defaultNode: ReactNode) => ReactNode;
    sectionDiv0Div0Div0Div0H10H1Props?: Partial<ComponentProps<"h1">>;
    /** Default: "Parenthood" */
    sectionDiv0Div0Div0Div0H10Span0SpanText?: ReactNode;
    /** Default: "icon" */
    sectionDiv0Div0Div0Div0ImageWithBasePath0ImageAlt?: string;
    /** Default: "/Templates/Doccure/img/icons/test.svg" */
    sectionDiv0Div0Div0Div0ImageWithBasePath0ImageSrc?: string;
    sectionDiv0Div0Div0Div0ImageWithBasePath0ImageVisible?: boolean;
    sectionDiv0Div0Div0Div0ImageWithBasePath0ImageRenderer?: (defaultNode: ReactNode) => ReactNode;
    sectionDiv0Div0Div0Div0ImageWithBasePath0ImageProps?: Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">>;
    /** Default: "all_routes.booking" */
    sectionDiv0Div0Div0Div0Link0LinkHref?: string;
    sectionDiv0Div0Div0Div0Link0LinkVisible?: boolean;
    sectionDiv0Div0Div0Div0Link0LinkRenderer?: (defaultNode: ReactNode) => ReactNode;
    sectionDiv0Div0Div0Div0Link0LinkProps?: Partial<ComponentProps<typeof SmartLink>>;
    /** Default: "Book Appointment . Book Appointment" */
    sectionDiv0Div0Div0Div0Link0Button0ButtonDataText?: string;
    sectionDiv0Div0Div0Div0Link0Button0ButtonVisible?: boolean;
    sectionDiv0Div0Div0Div0Link0Button0ButtonRenderer?: (defaultNode: ReactNode) => ReactNode;
    sectionDiv0Div0Div0Div0Link0Button0ButtonProps?: Partial<ComponentProps<"button">>;
    /** Default: "A gentle beginning to the family you’ve always dreamed of, supported by compassionate care and expert guidance at every step." */
    sectionDiv0Div0Div0Div0P0PText?: ReactNode;
    /** Default: "0.2s" */
    sectionDiv0Div0Div1Div0DivDataWowDelay?: string;
    /** Default: "1s" */
    sectionDiv0Div0Div1Div0DivDataWowDuration?: string;
    /** Default: "banner" */
    sectionDiv0Div0Div1Div0ImageWithBasePath0ImageAlt?: string;
    /** Default: "/Templates/Doccure/img/banner/banner-04.png" */
    sectionDiv0Div0Div1Div0ImageWithBasePath0ImageSrc?: string;
    sectionDiv0Div0Div1Div0ImageWithBasePath0ImageVisible?: boolean;
    sectionDiv0Div0Div1Div0ImageWithBasePath0ImageRenderer?: (defaultNode: ReactNode) => ReactNode;
    sectionDiv0Div0Div1Div0ImageWithBasePath0ImageProps?: Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">>;
    /** Default: "icon" */
    sectionDiv0Div0Div1Div0ImageWithBasePath1ImageAlt?: string;
    /** Default: "/Templates/Doccure/img/bg/banner-17.png" */
    sectionDiv0Div0Div1Div0ImageWithBasePath1ImageSrc?: string;
    sectionDiv0Div0Div1Div0ImageWithBasePath1ImageVisible?: boolean;
    sectionDiv0Div0Div1Div0ImageWithBasePath1ImageRenderer?: (defaultNode: ReactNode) => ReactNode;
    sectionDiv0Div0Div1Div0ImageWithBasePath1ImageProps?: Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">>;
    /** Default: "icon" */
    sectionDiv0Div0Div1Div0ImageWithBasePath2ImageAlt?: string;
    /** Default: "/Templates/Doccure/img/bg/plus-bg.png" */
    sectionDiv0Div0Div1Div0ImageWithBasePath2ImageSrc?: string;
    sectionDiv0Div0Div1Div0ImageWithBasePath2ImageVisible?: boolean;
    sectionDiv0Div0Div1Div0ImageWithBasePath2ImageRenderer?: (defaultNode: ReactNode) => ReactNode;
    sectionDiv0Div0Div1Div0ImageWithBasePath2ImageProps?: Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">>;
    /** Default: "bg" */
    sectionImageWithBasePath0ImageAlt?: string;
    /** Default: "/Templates/Doccure/img/bg/banner-11.png" */
    sectionImageWithBasePath0ImageSrc?: string;
    sectionImageWithBasePath0ImageVisible?: boolean;
    sectionImageWithBasePath0ImageRenderer?: (defaultNode: ReactNode) => ReactNode;
    sectionImageWithBasePath0ImageProps?: Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">>;
    /** Default: "bg" */
    sectionImageWithBasePath1ImageAlt?: string;
    /** Default: "/Templates/Doccure/img/bg/banner-12.png" */
    sectionImageWithBasePath1ImageSrc?: string;
    sectionImageWithBasePath1ImageVisible?: boolean;
    sectionImageWithBasePath1ImageRenderer?: (defaultNode: ReactNode) => ReactNode;
    sectionImageWithBasePath1ImageProps?: Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">>;
    /** Default: "bg" */
    sectionImageWithBasePath2ImageAlt?: string;
    /** Default: "/Templates/Doccure/img/bg/banner-13.png" */
    sectionImageWithBasePath2ImageSrc?: string;
    sectionImageWithBasePath2ImageVisible?: boolean;
    sectionImageWithBasePath2ImageRenderer?: (defaultNode: ReactNode) => ReactNode;
    sectionImageWithBasePath2ImageProps?: Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">>;
    /** Default: "bg" */
    sectionImageWithBasePath3ImageAlt?: string;
    /** Default: "/Templates/Doccure/img/bg/banner-14.png" */
    sectionImageWithBasePath3ImageSrc?: string;
    sectionImageWithBasePath3ImageVisible?: boolean;
    sectionImageWithBasePath3ImageRenderer?: (defaultNode: ReactNode) => ReactNode;
    sectionImageWithBasePath3ImageProps?: Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">>;
    /** Default: "bg" */
    sectionImageWithBasePath4ImageAlt?: string;
    /** Default: "/Templates/Doccure/img/bg/banner-15.png" */
    sectionImageWithBasePath4ImageSrc?: string;
    sectionImageWithBasePath4ImageVisible?: boolean;
    sectionImageWithBasePath4ImageRenderer?: (defaultNode: ReactNode) => ReactNode;
    sectionImageWithBasePath4ImageProps?: Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">>;
    /** Default: "bg" */
    sectionImageWithBasePath5ImageAlt?: string;
    /** Default: "/Templates/Doccure/img/bg/banner-16.png" */
    sectionImageWithBasePath5ImageSrc?: string;
    sectionImageWithBasePath5ImageVisible?: boolean;
    sectionImageWithBasePath5ImageRenderer?: (defaultNode: ReactNode) => ReactNode;
    sectionImageWithBasePath5ImageProps?: Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">>;
    spanImageWithBasePath0ImageProps?: Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">> | ((item: BannerSectionAvatarsItem) => Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">>);
    bannerSectionAvatars: BannerSectionAvatarsItem[];
    bannerSectionAvatarsItemWrapper?: (item: BannerSectionAvatarsItem, content: ReactNode) => ReactNode;
    bannerSectionAvatarsRenderer?: (defaultNode: ReactNode) => ReactNode;
    bannerSectionAvatarsImageVisible?: boolean;
    bannerSectionAvatarsImageRenderer?: (item: BannerSectionAvatarsItem, defaultNode: ReactNode) => ReactNode;
    bannerSectionAvatarsImageProps?: Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">> | ((item: BannerSectionAvatarsItem) => Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">>);
};

const HomeTenBannerSectionGenerated: FC<HomeTenBannerSectionGeneratedProps> = ({
    sectionDiv0Div0Div0Div0Div0Link0LinkHref = "all_routes.booking",
    sectionDiv0Div0Div0Div0Div0Link0LinkText = "Book Consultation",
    sectionDiv0Div0Div0Div0Div0Link0LinkVisible,
    sectionDiv0Div0Div0Div0Div0Link0LinkRenderer,
    sectionDiv0Div0Div0Div0Div0Link0LinkProps,
    sectionDiv0Div0Div0Div0Div0Link1LinkHref = "all_routes.search1",
    sectionDiv0Div0Div0Div0Div0Link1LinkText = "Search Specialist",
    sectionDiv0Div0Div0Div0Div0Link1LinkVisible,
    sectionDiv0Div0Div0Div0Div0Link1LinkRenderer,
    sectionDiv0Div0Div0Div0Div0Link1LinkProps,
    sectionDiv0Div0Div0Div0Div1Div0Link0LinkHref = "#",
    sectionDiv0Div0Div0Div0Div1Div0Link0LinkText = "10k+",
    sectionDiv0Div0Div0Div0Div1Div0Link0LinkVisible,
    sectionDiv0Div0Div0Div0Div1Div0Link0LinkRenderer,
    sectionDiv0Div0Div0Div0Div1Div0Link0LinkProps,
    sectionDiv0Div0Div0Div0Div1P0PText = "A trusted partner in every patient's fertility journey.",
    sectionDiv0Div0Div0Div0DivDataWowDelay = "0.2s",
    sectionDiv0Div0Div0Div0DivDataWowDuration = "1s",
    sectionDiv0Div0Div0Div0H10H1Text = "Your Journey to",
    sectionDiv0Div0Div0Div0H10H1Text2 = "Begins Here",
    sectionDiv0Div0Div0Div0H10H1Visible,
    sectionDiv0Div0Div0Div0H10H1Renderer,
    sectionDiv0Div0Div0Div0H10H1Props,
    sectionDiv0Div0Div0Div0H10Span0SpanText = "Parenthood",
    sectionDiv0Div0Div0Div0ImageWithBasePath0ImageAlt = "icon",
    sectionDiv0Div0Div0Div0ImageWithBasePath0ImageSrc = "/Templates/Doccure/img/icons/test.svg",
    sectionDiv0Div0Div0Div0ImageWithBasePath0ImageVisible,
    sectionDiv0Div0Div0Div0ImageWithBasePath0ImageRenderer,
    sectionDiv0Div0Div0Div0ImageWithBasePath0ImageProps,
    sectionDiv0Div0Div0Div0Link0Button0ButtonDataText = "Book Appointment . Book Appointment",
    sectionDiv0Div0Div0Div0Link0Button0ButtonVisible,
    sectionDiv0Div0Div0Div0Link0Button0ButtonRenderer,
    sectionDiv0Div0Div0Div0Link0Button0ButtonProps,
    sectionDiv0Div0Div0Div0Link0LinkHref = "all_routes.booking",
    sectionDiv0Div0Div0Div0Link0LinkVisible,
    sectionDiv0Div0Div0Div0Link0LinkRenderer,
    sectionDiv0Div0Div0Div0Link0LinkProps,
    sectionDiv0Div0Div0Div0P0PText = "A gentle beginning to the family you’ve always dreamed of, supported by compassionate care and expert guidance at every step.",
    sectionDiv0Div0Div1Div0DivDataWowDelay = "0.2s",
    sectionDiv0Div0Div1Div0DivDataWowDuration = "1s",
    sectionDiv0Div0Div1Div0ImageWithBasePath0ImageAlt = "banner",
    sectionDiv0Div0Div1Div0ImageWithBasePath0ImageSrc = "/Templates/Doccure/img/banner/banner-04.png",
    sectionDiv0Div0Div1Div0ImageWithBasePath0ImageVisible,
    sectionDiv0Div0Div1Div0ImageWithBasePath0ImageRenderer,
    sectionDiv0Div0Div1Div0ImageWithBasePath0ImageProps,
    sectionDiv0Div0Div1Div0ImageWithBasePath1ImageAlt = "icon",
    sectionDiv0Div0Div1Div0ImageWithBasePath1ImageSrc = "/Templates/Doccure/img/bg/banner-17.png",
    sectionDiv0Div0Div1Div0ImageWithBasePath1ImageVisible,
    sectionDiv0Div0Div1Div0ImageWithBasePath1ImageRenderer,
    sectionDiv0Div0Div1Div0ImageWithBasePath1ImageProps,
    sectionDiv0Div0Div1Div0ImageWithBasePath2ImageAlt = "icon",
    sectionDiv0Div0Div1Div0ImageWithBasePath2ImageSrc = "/Templates/Doccure/img/bg/plus-bg.png",
    sectionDiv0Div0Div1Div0ImageWithBasePath2ImageVisible,
    sectionDiv0Div0Div1Div0ImageWithBasePath2ImageRenderer,
    sectionDiv0Div0Div1Div0ImageWithBasePath2ImageProps,
    sectionImageWithBasePath0ImageAlt = "bg",
    sectionImageWithBasePath0ImageSrc = "/Templates/Doccure/img/bg/banner-11.png",
    sectionImageWithBasePath0ImageVisible,
    sectionImageWithBasePath0ImageRenderer,
    sectionImageWithBasePath0ImageProps,
    sectionImageWithBasePath1ImageAlt = "bg",
    sectionImageWithBasePath1ImageSrc = "/Templates/Doccure/img/bg/banner-12.png",
    sectionImageWithBasePath1ImageVisible,
    sectionImageWithBasePath1ImageRenderer,
    sectionImageWithBasePath1ImageProps,
    sectionImageWithBasePath2ImageAlt = "bg",
    sectionImageWithBasePath2ImageSrc = "/Templates/Doccure/img/bg/banner-13.png",
    sectionImageWithBasePath2ImageVisible,
    sectionImageWithBasePath2ImageRenderer,
    sectionImageWithBasePath2ImageProps,
    sectionImageWithBasePath3ImageAlt = "bg",
    sectionImageWithBasePath3ImageSrc = "/Templates/Doccure/img/bg/banner-14.png",
    sectionImageWithBasePath3ImageVisible,
    sectionImageWithBasePath3ImageRenderer,
    sectionImageWithBasePath3ImageProps,
    sectionImageWithBasePath4ImageAlt = "bg",
    sectionImageWithBasePath4ImageSrc = "/Templates/Doccure/img/bg/banner-15.png",
    sectionImageWithBasePath4ImageVisible,
    sectionImageWithBasePath4ImageRenderer,
    sectionImageWithBasePath4ImageProps,
    sectionImageWithBasePath5ImageAlt = "bg",
    sectionImageWithBasePath5ImageSrc = "/Templates/Doccure/img/bg/banner-16.png",
    sectionImageWithBasePath5ImageVisible,
    sectionImageWithBasePath5ImageRenderer,
    sectionImageWithBasePath5ImageProps,
    spanImageWithBasePath0ImageProps,
    sectionDiv0Div0ClassName,
    bannerSectionAvatars,
    bannerSectionAvatarsItemWrapper,
    bannerSectionAvatarsRenderer,
    bannerSectionAvatarsImageVisible,
    bannerSectionAvatarsImageRenderer,
    bannerSectionAvatarsImageProps,
}) => {
    return (
        <section className="banner-section-ten">
            <div className="container">
                <div className={sectionDiv0Div0ClassName ?? "row align-items-end"}>
                    <div className="col-lg-7">
                        <div className="banner-content wow fadeInUp" data-wow-delay={sectionDiv0Div0Div0Div0DivDataWowDelay} data-wow-duration={sectionDiv0Div0Div0Div0DivDataWowDuration}>
                            {renderNode(sectionDiv0Div0Div0Div0H10H1Visible, sectionDiv0Div0Div0Div0H10H1Renderer, (
                                <h1 {...(sectionDiv0Div0Div0Div0H10H1Props ?? {})}>
                                    {sectionDiv0Div0Div0Div0H10H1Text}
                                    <span>{sectionDiv0Div0Div0Div0H10Span0SpanText}</span>
                                    {sectionDiv0Div0Div0Div0H10H1Text2}
                                </h1>
                            ))}
                            <p>{sectionDiv0Div0Div0Div0P0PText}</p>
                            <div className="banner-btns">
                                {renderNode(sectionDiv0Div0Div0Div0Div0Link0LinkVisible, sectionDiv0Div0Div0Div0Div0Link0LinkRenderer, (
                                    <SmartLink href={sectionDiv0Div0Div0Div0Div0Link0LinkHref} className="btn btn-secondary" {...(sectionDiv0Div0Div0Div0Div0Link0LinkProps ?? {})}>
                                        <i className="isax isax-calendar-edit me-2" />
                                        {sectionDiv0Div0Div0Div0Div0Link0LinkText}
                                    </SmartLink>
                                ))}
                                {renderNode(sectionDiv0Div0Div0Div0Div0Link1LinkVisible, sectionDiv0Div0Div0Div0Div0Link1LinkRenderer, (
                                    <SmartLink href={sectionDiv0Div0Div0Div0Div0Link1LinkHref} className="btn btn-primary" {...(sectionDiv0Div0Div0Div0Div0Link1LinkProps ?? {})}>
                                        <i className="isax isax-calendar-edit me-2" />
                                        {sectionDiv0Div0Div0Div0Div0Link1LinkText}
                                    </SmartLink>
                                ))}
                            </div>
                            <div className="banner-user">
                                <div className="avatar-list-stacked">
                                    {renderCollectionNode(
                                        bannerSectionAvatars,
                                        (item: BannerSectionAvatarsItem) => (
                                            <span className={item.className ?? "avatar"} key={item.key}>
                                                {renderItemNode(bannerSectionAvatarsImageVisible, bannerSectionAvatarsImageRenderer, item, (
                                                    <SmartImage src={item.src} alt={item.alt ?? "patient"} className={item.imageWithBasePath0ClassName ?? "img-fluid rounded-circle"} {...(typeof bannerSectionAvatarsImageProps === "function" ? bannerSectionAvatarsImageProps(item) : (bannerSectionAvatarsImageProps ?? {}))} {...(typeof spanImageWithBasePath0ImageProps === "function" ? spanImageWithBasePath0ImageProps(item) : (spanImageWithBasePath0ImageProps ?? {}))} />
                                                ))}
                                            </span>
                                        ),
                                        bannerSectionAvatarsItemWrapper,
                                        bannerSectionAvatarsRenderer
                                    )}
                                    {renderNode(sectionDiv0Div0Div0Div0Div1Div0Link0LinkVisible, sectionDiv0Div0Div0Div0Div1Div0Link0LinkRenderer, (
                                        <SmartLink href={sectionDiv0Div0Div0Div0Div1Div0Link0LinkHref} className="avatar avatar-rounded avatar-text" {...(sectionDiv0Div0Div0Div0Div1Div0Link0LinkProps ?? {})}>{sectionDiv0Div0Div0Div0Div1Div0Link0LinkText}</SmartLink>
                                    ))}
                                </div>
                                <p>{sectionDiv0Div0Div0Div0Div1P0PText}</p>
                            </div>
                            {renderNode(sectionDiv0Div0Div0Div0Link0LinkVisible, sectionDiv0Div0Div0Div0Link0LinkRenderer, (
                                <SmartLink href={sectionDiv0Div0Div0Div0Link0LinkHref} {...(sectionDiv0Div0Div0Div0Link0LinkProps ?? {})}>
                                    {renderNode(sectionDiv0Div0Div0Div0Link0Button0ButtonVisible, sectionDiv0Div0Div0Div0Link0Button0ButtonRenderer, (
                                        <button className="animate-button" data-text={sectionDiv0Div0Div0Div0Link0Button0ButtonDataText} {...(sectionDiv0Div0Div0Div0Link0Button0ButtonProps ?? {})}>
                                            <p className="button-text" />
                                            <span className="button-circle">
                                                <i className="isax isax-arrow-right-1" />
                                            </span>
                                        </button>
                                    ))}
                                </SmartLink>
                            ))}
                            {renderNode(sectionDiv0Div0Div0Div0ImageWithBasePath0ImageVisible, sectionDiv0Div0Div0Div0ImageWithBasePath0ImageRenderer, (
                                <SmartImage src={sectionDiv0Div0Div0Div0ImageWithBasePath0ImageSrc} alt={sectionDiv0Div0Div0Div0ImageWithBasePath0ImageAlt} className="banner-img" {...(sectionDiv0Div0Div0Div0ImageWithBasePath0ImageProps ?? {})} />
                            ))}
                        </div>
                    </div>
                    <div className="col-lg-5">
                        <div className="banner-img wow fadeInUp" data-wow-delay={sectionDiv0Div0Div1Div0DivDataWowDelay} data-wow-duration={sectionDiv0Div0Div1Div0DivDataWowDuration}>
                            {renderNode(sectionDiv0Div0Div1Div0ImageWithBasePath0ImageVisible, sectionDiv0Div0Div1Div0ImageWithBasePath0ImageRenderer, (
                                <SmartImage src={sectionDiv0Div0Div1Div0ImageWithBasePath0ImageSrc} className="img-fluid banner-image" alt={sectionDiv0Div0Div1Div0ImageWithBasePath0ImageAlt} {...(sectionDiv0Div0Div1Div0ImageWithBasePath0ImageProps ?? {})} />
                            ))}
                            {renderNode(sectionDiv0Div0Div1Div0ImageWithBasePath1ImageVisible, sectionDiv0Div0Div1Div0ImageWithBasePath1ImageRenderer, (
                                <SmartImage src={sectionDiv0Div0Div1Div0ImageWithBasePath1ImageSrc} alt={sectionDiv0Div0Div1Div0ImageWithBasePath1ImageAlt} className="banner-bg-07" {...(sectionDiv0Div0Div1Div0ImageWithBasePath1ImageProps ?? {})} />
                            ))}
                            {renderNode(sectionDiv0Div0Div1Div0ImageWithBasePath2ImageVisible, sectionDiv0Div0Div1Div0ImageWithBasePath2ImageRenderer, (
                                <SmartImage src={sectionDiv0Div0Div1Div0ImageWithBasePath2ImageSrc} alt={sectionDiv0Div0Div1Div0ImageWithBasePath2ImageAlt} className="banner-bg-08" {...(sectionDiv0Div0Div1Div0ImageWithBasePath2ImageProps ?? {})} />
                            ))}
                        </div>
                    </div>
                </div>
            </div>
            {renderNode(sectionImageWithBasePath0ImageVisible, sectionImageWithBasePath0ImageRenderer, (
                <SmartImage src={sectionImageWithBasePath0ImageSrc} alt={sectionImageWithBasePath0ImageAlt} className="banner-bg-01" {...(sectionImageWithBasePath0ImageProps ?? {})} />
            ))}
            {renderNode(sectionImageWithBasePath1ImageVisible, sectionImageWithBasePath1ImageRenderer, (
                <SmartImage src={sectionImageWithBasePath1ImageSrc} alt={sectionImageWithBasePath1ImageAlt} className="banner-bg-02" {...(sectionImageWithBasePath1ImageProps ?? {})} />
            ))}
            {renderNode(sectionImageWithBasePath2ImageVisible, sectionImageWithBasePath2ImageRenderer, (
                <SmartImage src={sectionImageWithBasePath2ImageSrc} alt={sectionImageWithBasePath2ImageAlt} className="banner-bg-03" {...(sectionImageWithBasePath2ImageProps ?? {})} />
            ))}
            {renderNode(sectionImageWithBasePath3ImageVisible, sectionImageWithBasePath3ImageRenderer, (
                <SmartImage src={sectionImageWithBasePath3ImageSrc} alt={sectionImageWithBasePath3ImageAlt} className="banner-bg-04" {...(sectionImageWithBasePath3ImageProps ?? {})} />
            ))}
            {renderNode(sectionImageWithBasePath4ImageVisible, sectionImageWithBasePath4ImageRenderer, (
                <SmartImage src={sectionImageWithBasePath4ImageSrc} alt={sectionImageWithBasePath4ImageAlt} className="banner-bg-05" {...(sectionImageWithBasePath4ImageProps ?? {})} />
            ))}
            {renderNode(sectionImageWithBasePath5ImageVisible, sectionImageWithBasePath5ImageRenderer, (
                <SmartImage src={sectionImageWithBasePath5ImageSrc} alt={sectionImageWithBasePath5ImageAlt} className="banner-bg-06" {...(sectionImageWithBasePath5ImageProps ?? {})} />
            ))}
        </section>
    );
};

export default HomeTenBannerSectionGenerated;
